import React from 'react';
import { Modal, ModalHeader, ModalBody, Badge, ListGroup, ListGroupItem } from 'reactstrap';
import { IconHeart } from '@tabler/icons-react';
import { IInvestorFavorite } from '../models/dashboardModels';

interface InvestorFavoritesModalProps {
  isOpen: boolean;
  toggle: () => void;
  investorName: string;
  favorites: IInvestorFavorite[];
  currentListingId?: string;
}

const listingTypeLabel: Record<string, string> = {
  project: 'Proyecto',
  'property-sales': 'Propiedad en venta',
  'property-rent': 'Propiedad en renta',
};

const listingTypeBadgeColor: Record<string, string> = {
  project: 'info',
  'property-sales': 'success',
  'property-rent': 'warning',
};

const InvestorFavoritesModal: React.FC<InvestorFavoritesModalProps> = ({
  isOpen,
  toggle,
  investorName,
  favorites,
  currentListingId,
}) => {
  const namedFavorites = favorites.filter(
    (favorite) => favorite.project_name || favorite.property_name,
  );

  return (
    <Modal isOpen={isOpen} toggle={toggle} className="modal-dialog-centered">
      <ModalHeader toggle={toggle}>
        Favoritos de {investorName}
      </ModalHeader>
      <ModalBody>
        {namedFavorites.length === 0 ? (
          <p className="text-muted mb-0">Este usuario no tiene favoritos.</p>
        ) : (
          <ListGroup flush>
            {namedFavorites.map((favorite) => {
              const isCurrentListing = favorite.listing_id === currentListingId;
              return (
                <ListGroupItem
                  key={favorite.id}
                  className="d-flex align-items-center justify-content-between"
                >
                  <div className="d-flex align-items-center">
                    <IconHeart
                      size={16}
                      className={`me-2 ${
                        isCurrentListing ? 'text-danger' : 'text-muted'
                      }`}
                    />
                    <span
                      className={
                        isCurrentListing ? 'text-danger font-weight-bold' : ''
                      }
                    >
                      {(favorite.project_code || favorite.property_code) &&
                        `[${favorite.project_code || favorite.property_code}] `}
                      {favorite.project_name || favorite.property_name}
                      {isCurrentListing && ' (Agendó/Visitó)'}
                    </span>
                  </div>
                  <Badge
                    color={
                      isCurrentListing
                        ? 'danger'
                        : listingTypeBadgeColor[favorite.listing_type] ||
                          'secondary'
                    }
                    pill
                  >
                    {listingTypeLabel[favorite.listing_type] || 'Favorito'}
                  </Badge>
                </ListGroupItem>
              );
            })}
          </ListGroup>
        )}
      </ModalBody>
    </Modal>
  );
};

export default InvestorFavoritesModal;
